import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'url-search-params-polyfill'
import VModal from 'vue-js-modal'

Vue.use(VModal);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
